import PropTypes from 'prop-types';

import { StyledContainer, Img, ImageWrapper } from './styles';

const ImageOnlyBanner = ({ data }) => {
  if (!data) return false;

  const { imageDam, backgroundColor } = data;

  return (
    <StyledContainer backgroundColor={backgroundColor}>
      {imageDam && (
        <ImageWrapper>
          <Img src={imageDam} alt={imageDam.altText || ''} objectFit="cover" />
        </ImageWrapper>
      )}
    </StyledContainer>
  );
};

ImageOnlyBanner.propTypes = {
  data: PropTypes.shape(),
};

export default ImageOnlyBanner;
